<template src="./BP_PolicyPlanLocation.html">
</template>

<script>
import axios from "axios";
import * as common from "@/common.js";
import * as spaApi from "@/spaApi.js";
import { bpoffice } from "@/constants";

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
    name: "location-section",
    props: {
      name:{
          type: String
      },
      parentPageName:{
          type: String,
          default: ''
      },
      locationData: {
          type: Object,
          default() {
              return {};
          }
      },
      bpUserLocation: {
        type: Object,
        default() {
          return {};
        }
      },
      disableControls: {
        type: Boolean
      },
      fireValidation: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },
    data() {
      return {
        hasAccessToAllRegions: false,
        allregions: [],
        selectedRegionId: null,
        selectedOfficeId: null,
        selectedDepartmentId: null,  
          
      };
    },
    computed: {
      selectedRegion() {
        if (!this.allregions || !this.selectedRegionId) {
          return null
        }
        return this.allregions.find(r => r.id === this.selectedRegionId) || null;
      },
      selectedOffice() {
        if (!this.selectedRegion || !this.selectedRegion.offices || !this.selectedOfficeId) {
          return null;
        }
          const office = this.selectedRegion.offices.find(o => o.id === this.selectedOfficeId) || null;
          return office;
        },
      selectedDepartment() {
        if (!this.selectedRegion || !this.selectedRegion.offices || !this.selectedOfficeId) {
          return null;
        }

        const office = this.selectedRegion.offices.find(o => o.id === this.selectedOfficeId);
        if (!office || !office.departments) return null;
        const dept =
          office.departments.find(d => d.id === this.locationData.departmentId) ||
          office.departments[0] ||
          null;

        return dept;
      }
    },
    mounted() {
        this.init();
    },
    watch: {
      locationData(newValues, oldValues) {
            const {
                officeId,
                officeName,
                departmentId,
                departmentName,
            } = this.locationData;
            const officeChange = newValues.officeId !== oldValues.officeId;
            const departmentChange = newValues.departmentId !== oldValues.departmentId;

            if (officeChange) this.officeData = common.buildDefaultOption(officeId, officeName);
            if (departmentChange) this.departmentData = common.buildDefaultOption(departmentId, departmentName);
      },
      selectedOfficeId() {
        this.onOfficeChange()
      },
      selectedRegionId() {
        this.onRegionChange()
      },
      selectedDepartmentId(newId) {
        const d = this.selectedOffice.departments.find(x => x.id === newId);
        if (d) {
          this.locationData.departmentId = d.id;
          this.locationData.departmentName = d.name;
          this.departmentData = common.buildDefaultOption(d.id, d.name);
        }
      }
    },
    methods: {
      async init() {
        await spaApi.getAllRegions().then(x => {
          this.allregions = x
        })
        if (this.bpUserLocation.officeId === bpoffice.main) {
          this.hasAccessToAllRegions = true;
        }
      },
      assignOnFly(incoming) {
        this.selectedRegionId = incoming.account.regionId
        this.locationData.regionId = incoming.account.regionId
        this.locationData.regionName = incoming.account.regionName
        this.locationData.officeId = incoming.account.officeId
        this.locationData.officeName = incoming.account.officeName
        this.selectedOfficeId = incoming.account.officeId
        this.locationData.departmentId = incoming.account.departmentId
        this.locationData.departmentName = incoming.account.departmentName
        this.selectedDepartmentId = incoming.account.departmentId
      },
      onRegionChange() {
        var r = this.selectedRegion;
        if (r) {
          this.locationData.regionId = r.id
          this.locationData.regionName = r.name
          if (!this.selectedOffice && (r && r.offices && r.offices.length > 0)) {
            this.selectedOfficeId = r.offices[0].id;
            this.selectedDepartmentId = r.offices[0].departments[0].id
          }
        }
      },
      onOfficeChange() {
        var o = this.selectedRegion.offices.find(x => x.id === this.selectedOfficeId);
        if (o) {
            this.locationData.officeId = o.id;
            this.locationData.officeName = o.name;
            if (o.id && o.name) {
              this.officeData = common.buildDefaultOption(o.id, o.name);
            } else {
              this.officeData = null;
            }
        } else {
          this.officeData = null;
        }
        if (!this.selectedDepartment && (o && o.departments && o.departments.length > 0)) {
          var d = o.departments[0];
          this.selectedDepartmentId = (d.id != null ? d.id : d.name);
        }
      },
      onDeptChange() {
        const d = this.selectedOffice.departments.find(x => x.id === this.selectedDepartmentId)
        if (d) {
            this.locationData.departmentId = d.id;
            this.locationData.departmentName = d.name;
            this.departmentData = common.buildDefaultOption(d.id, d.name);
        }
      }
    }
};

</script>
